export default "__VITE_ASSET__86312cb1__"